import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isDataFeedsConnected?: boolean }>()(
  (theme, { isDataFeedsConnected }) => ({
    paymentDueDate: {
      color: theme.palette.error.dark,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
    companyName: {
      fontSize: '14px',
    },
    image: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: theme.spacing(3),
      objectFit: 'contain',
    },
    buyerName: {
      display: 'flex',
      gap: theme.spacing(1.25),
    },
    placeholder: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: theme.spacing(3),
      color: '#EEEEEE',
    },
    buyerNameText: {
      color: theme.palette.shadows.dark,
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    toolTipWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.375),
    },
    grossRevenue: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
    },
    listingWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    toolTipText: {
      color: theme.palette.textBackground.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '16px',
    },
    table: {
      width: '100%',
      '& .MuiTableRow-root': {
        cursor: isDataFeedsConnected ? 'pointer' : '',
      },
      '& .MuiChip-outlined': {
        cursor: isDataFeedsConnected ? 'pointer' : '',
      },
      marginBottom: theme.spacing(-5),
    },
    responseText: {
      color: theme.palette.labraText.primary,
      textAlign: 'center',
      fontFamily: 'Poppins',
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '28px',
    },
    responseStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '-webkit-fill-available',
      borderRadius: theme.spacing(0.5),
      border: `1px solid ${theme.palette.dividerV2.main}`,
      padding: theme.spacing(4, 5, 4, 5),
    },
    dataFeedsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    headerText: {
      fontFamily: 'Poppins',
      fontSize: '22px',
      fontWeight: 400,
      color: theme.palette.button.primary,
    },
  })
)
